export default __webpack_public_path__ + "static/media/drawn-highlighted-map-poi-icon.33ae56d1.svg";